class i4_Filter {
	constructor(element) {
		this.$element = $(element);
		this.filterDebounceTimeout = null;
		this.currentPage = 1;
		this.siblingPageButtonsVisible = 2;

		this.selectors = {
			filterElement: '.js-filter-element',
			filterLoader: '.js-filter-loader',
			filterResult: '.js-filter-result',
			filterPrevious: '.js-filter-prev',
			filterNext: '.js-filter-next',
			filterPagination: '.js-filter-pagination',
			filterShowAll: '.js-filter-show-all',
			filterShowPagination: '.js-filter-show-pagination'
		};

		this.data = {
			pluginName: 'plugin-name',
			call: 'call',
			ajaxParameter: 'ajax-parameter',
			hideWhileLoading: 'hide-while-loading',
			togglePagination: 'toggle-pagination',
			countPerPage: 'count-per-page'
		};

		this.triggers = {
			beforeFiltered: 'i4:beforeFiltered',
			afterFiltered: 'i4:afterFiltered',
			updateFilter: 'i4:updateFilter'
		};
	}

	init() {

		// console.log('init i4_Filter');

		this.dataPluginName = this.$element.data(this.data.pluginName);
		this.dataCall = this.$element.data(this.data.call);
		this.dataAjaxParameter = this.$element.data(this.data.ajaxParameter);
		this.dataHideWhileLoading = this.$element.data(this.data.hideWhileLoading) !== undefined;
		this.dataTogglePagination = this.$element.data(this.data.togglePagination) !== undefined;
		this.dataCountPerPage = this.$element.data(this.data.countPerPage);

		this.countPerPage = this.dataCountPerPage !== undefined ? this.dataCountPerPage : null;

		this.$filterElements = this.$element.find(this.selectors.filterElement);
		this.$filterResult = this.$element.find(this.selectors.filterResult);
		this.$filterLoader = this.$element.find(this.selectors.filterLoader);

		this.$filterPrevious = this.$element.find(this.selectors.filterPrevious);
		this.$filterNext = this.$element.find(this.selectors.filterNext);
		this.$filterPagination = this.$element.find(this.selectors.filterPagination);
		this.$filterShowAll = this.$element.find(this.selectors.filterShowAll);
		this.$filterShowPagination = this.$element.find(this.selectors.filterShowPagination);

		this.$element.on(this.triggers.updateFilter, this.forceFilter.bind(this));

		this.runFilter(true);

		this.observeFilterElements();

		this.updateNavigationButtons();

		if (this.countPerPage) {
			this.$filterPrevious.on('click', this.$onClickPrevious.bind(this));
			this.$filterNext.on('click', this.$onClickNext.bind(this));
		}

		if (this.dataTogglePagination) {
			this.$filterShowPagination.hide();
			this.$filterShowAll.hide();
			this.$filterShowAll.on('click', this.$onClickShowAll.bind(this));
			this.$filterShowPagination.on('click', this.$onClickShowPagination.bind(this));
		}
	}

	runFilter(immediate) {
		this.debounce(this.filter, 400, immediate)();
	}

	forceFilter() {
		this.lastAjaxParams = {};
		this.filter();
	}

	filter() {
		let params = {
			js: this.dataPluginName,
			call: this.dataCall
		};

		if (this.countPerPage) {
			params = Object.assign(params, {
				count_per_page: this.countPerPage,
				page: this.currentPage
			});
		}

		params = Object.assign(params, this.dataAjaxParameter);

		this.$filterElements.each((i, item) => {
			const $item = $(item);
			let elementName = $item.attr('name');
			if (elementName === undefined) {
				elementName = $item.find('input').attr('name');
			}
			params[elementName] = this.getFilterValue($item);
		});

		// console.log('params', params);

		if (JSON.stringify(this.lastAjaxParams) !== JSON.stringify(params)) {

			this.$filterLoader.show();

			if (this.dataHideWhileLoading) {
				this.$filterResult.hide();
			}

			this.$element.trigger(this.triggers.beforeFiltered);

			i4_Ajax.factory().
				set_parameter(jQuery.param(params)).
				set_option({
					on_complete: (response, responseJSON) => {
				
						if (responseJSON) {
							if (responseJSON.count === undefined || responseJSON.output === undefined) {
								console.warn('count or output in responseJSON missing!', responseJSON);
							} else {
								if (this.countPerPage) {
									this.count = parseInt(responseJSON.count);
									this.totalPages = Math.ceil(this.count / this.countPerPage);
									
									if (this.count !== 0 && this.currentPage > this.totalPages) {
										this.currentPage = this.totalPages;
										this.runFilter();
									} else {
										this.$filterResult.html(responseJSON.output);
										this.renderPagination();
										this.updateNavigationButtons();
										this.showResult();
									}
								} else {
									this.totalPages = 1;
									this.$filterResult.html(responseJSON.output);
									this.renderPagination();
									this.updateNavigationButtons();
									this.showResult();
								}
							}
							
						} else {
							this.$filterResult.html(response);
							this.showResult();
						}
					}
				}).
				run();	
				
		}
		
		this.lastAjaxParams = params;
	}

	showResult() {
		this.$filterLoader.hide();
		this.$filterResult.show();
		this.$element.trigger(this.triggers.afterFiltered);
	}

	observeFilterElements() {

		this.$filterElements.each((i, item) => {
			$(item).on('i4:change', () => {
				this.runFilter(false);
			});
		});

	}

	getFilterValue($formItem) {
		var result = '';
		
		if ($formItem.prop('tagName') === 'INPUT' && ($.inArray($formItem.attr('type'), ['text', 'hidden']) >= 0)) {
			result = $formItem.val();
		} else if ($formItem.prop('tagName') === 'INPUT' && $formItem.attr('type') === 'checkbox') {
			if ($formItem.is(':checked')) {
				result = true;
			} else {
				result = false;
			}
		} else if ($formItem.find('input[type=radio]').length) {
			$formItem.find('input[type=radio]').each(function(i, input) {
				const $input = $(input);
				if ($input.is(':checked')) {
					result = $input.val();
					return false; // break;
				}
			});
		} else if ($formItem.prop('tagName') === 'SELECT') {
			result = $formItem.val();
		}

		return result;
	}

	$onClickShowAll() {
		this.countPerPage = undefined;
		this.runFilter();

		this.$filterPrevious.hide();
		this.$filterNext.hide();
		this.$filterPagination.hide();
		this.$filterShowAll.hide();
		this.$filterShowPagination.show();
	}
	
	$onClickShowPagination() {
		this.countPerPage = this.dataCountPerPage;
		this.runFilter();
		this.updateNavigationButtons();
		this.renderPagination();

		this.$filterShowAll.show();
		this.$filterShowPagination.hide();
	}

	$onClickPrevious() {
		if (this.currentPage > 1) {
			this.currentPage -= 1;
			this.filter();
		}
	}

	$onClickNext() {
		if (this.currentPage < this.totalPages) {
			this.currentPage += 1;
			this.filter();
		}
	}

	goToPage(pageNumber) {
		if (pageNumber > 0 || pageNumber < this.totalPages) {
			this.currentPage = pageNumber;
		} else {
			this.currentPage = 1;
		}

		this.filter();
	}

	renderPagination() {
		if (this.totalPages > 1) {
			const $pagination = $('<ul>');

			for (let i = 0; i < this.totalPages; i++) {
				const pageNumber = i+1;
				const $page = $('<li>');

				if (
					(i === 0 || i === this.totalPages-1) || 
					(this.currentPage === pageNumber) || 
					(
						(this.currentPage - this.siblingPageButtonsVisible <= pageNumber) && 
						(this.currentPage + this.siblingPageButtonsVisible >= pageNumber)
					) 
				) {
					$page.append($('<button>')
						.addClass('i4-button')
						.addClass('i4-button--small')
						.addClass(() => {return pageNumber === this.currentPage ? 'invalid' : false;})
						.text(pageNumber));
					$page.on('click', () => this.goToPage(pageNumber));
					
					if (pageNumber === this.currentPage) {
						$page.addClass('current');
					} 
				} else if (
					this.currentPage - (this.siblingPageButtonsVisible+1) === pageNumber || 
					this.currentPage + (this.siblingPageButtonsVisible+1) === pageNumber) 
				{
					$page.text('...');
				}

				if (!$page.is(':empty')) {
					$pagination.append($page);
				}
			}

			this.$filterPagination.html($pagination);
			this.$filterPagination.show();
			this.$filterShowAll.show();
		} else {
			this.$filterPagination.hide();
		}
	}

	updateNavigationButtons() {
		if (this.totalPages > 1) {
			this.$filterPrevious.show();
			this.$filterNext.show();
			this.$filterPrevious.toggleClass('invalid', this.currentPage === 1);
			this.$filterNext.toggleClass('invalid', this.currentPage === this.totalPages);
		} else {
			this.$filterPrevious.hide();
			this.$filterNext.hide();
		}
	}

	debounce(func, wait, immediate) {
		return () => {
			var context = this, args = arguments;
			var later = function() {
				this.filterDebounceTimeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !this.filterDebounceTimeout;
			clearTimeout(this.filterDebounceTimeout);
			this.filterDebounceTimeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}
}

